import gql from 'graphql-tag';
import { RatingFields } from '../../common-fields.queries';
import { ProductFamilyFields } from '../product-family-fragment.queries';
import { ProductVariantFields, ProductBrandFields } from '../product.queries';

export const PLA = gql`
	${ProductFamilyFields}
	${ProductVariantFields}
	${ProductBrandFields}
	${RatingFields}
	query PLAPage(
		$id: Int!
		$variantId: Int
		$productStatus: [ProductStatusEnum!] = [stock]
		$onlyKeySpecs: Boolean = true
		$regionId: String
	) {
		productFamily(id: $id, variantId: $variantId, regionId: $regionId) {
			... on ProductFamily {
				...ProductFamilyFields
				handleType
				brandInfo {
					...ProductBrandFields
				}
				variants(status: $productStatus) {
					...ProductVariantFields
				}
				attributeGroups(onlyKeySpecs: $onlyKeySpecs) {
					name
					attributes {
						id
						name
						values
						units
						description
						isHidden
					}
				}
				collection {
					name
				}
				reviewSummary {
					...RatingFields
				}
				hasRecommendedOptions
				isConfigurable
				isDiscontinued
				hasAccessories
			}
			... on NotFoundError {
				message
			}
		}
	}
`;
